import React from "react";
import { Row, Col } from "reactstrap";

interface FormFieldRowProps {
  spacing?: 'first' | 'subsequent';
  children: React.ReactNode;
  className?: string;
}

const FormFieldRow: React.FC<FormFieldRowProps> = ({
  spacing = 'subsequent',
  children,
  className
}) => {
  const spacingClass = spacing === 'first' ? 'mt-4' : 'mt-3';

  return (
    <Row className={`${spacingClass} justify-content-center gx-4 ${className || ''}`}>
      {React.Children.map(children, (child, index) => (
        <Col md="4" key={index}>
          {child}
        </Col>
      ))}
    </Row>
  );
};

export default FormFieldRow;